import script from "./CxSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./CxSpinner.vue?vue&type=style&index=0&id=7c089cc0&lang=less"

const __exports__ = script;

export default __exports__